<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Daily Challenge Test">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Name is required</div>
        </div>

        <div class="col-md-6 form-group">
          Description
          <input
            class="form-control"
            type="text"
            v-model="description"
            @focus="descriptionEmpty = false"
          />
          <div v-if="descriptionEmpty" style="color: red">
            Description is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Number Of Attempts
          <input class="form-control" type="text" value="1" readonly />
        </div>
        <div class="col-md-6 form-group">
          Negative Marks
          <input
            class="form-control"
            type="number"
            v-model="negativeMarks"
            @focus="negativeMarkEmpty = false"
          />
          <div v-if="negativeMarkEmpty" style="color: red">
            Negative mark is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Each Question Mark
          <input
            class="form-control"
            type="number"
            v-model="eachQuestionMark"
            @focus="eachQuestionMarkEmpty = false"
          />
          <div v-if="eachQuestionMarkEmpty" style="color: red">
            Each question mark is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Result Status
          <b-form-select
            v-model="resultStatus"
            @change="resultStatusEmpty = false"
          >
            <option
              v-for="(resultStatusOption, index) in resultStatusOptions"
              :key="index"
              :value="resultStatusOption.value"
            >
              {{ resultStatusOption.text }}
            </option>
          </b-form-select>
          <div v-if="resultStatusEmpty" style="color: red">
            Result status is required
          </div>
        </div>

        <div class="col-md-12" v-if="durations2.length > 0">
          Duration Details
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Duration</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(duration, index) in durations2" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ duration.name }} </b-td>
                <b-td class="text-center"> {{ duration.duration2 }} </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="col-md-12" v-if="finalArray2 != ''">
          Test Contents
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Topic</b-th>
                <b-th class="text-center">Subtopic</b-th>
                <b-th class="text-center">Question Conut</b-th>
                <b-th class="text-center">Action</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(final, index) in finalArray2" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ final.parentTopic.name }} </b-td>
                <b-td class="text-center">{{ final.topic.name }}</b-td>
                <b-td class="text-center"> {{ final.subtopic.name }} </b-td>
                <b-td class="text-center"> {{ final.questionCount }} </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="removeRowRandom(index, final.parentTopic)"
                  >
                    <i class="fa fa-fw fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="form-group col-md-3" v-if="finalArray2 != ''">
          Overall Question Count
          <input
            class="form-control"
            type="text"
            :value="
              finalArray2.length > 0
                ? finalArray2
                    .map((ele) => parseInt(ele.questionCount) || 0)
                    .reduce((a, b) => a + b)
                : 0
            "
            readonly
          />
        </div>

        <div
          :class="
            finalArray2 != ''
              ? 'col-md-9 mt-4 form-group'
              : 'col-md-12 mt-4 form-group'
          "
          v-if="resultStatus != ''"
        >
          <b-button
            class="float-right"
            variant="success"
            v-b-modal.modal-3
            @click="getParentTopics()"
            >Add Questions</b-button
          >
        </div>

        <!-- Random Modal -->
        <b-modal
          id="modal-3"
          title="Add Questions"
          size="xl"
          ref="modalthree"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="closeRandom()"
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Parent Topic
              <b-form-select
                v-model="parentTopic"
                @change="getTopics()"
                required
              >
                <option
                  v-for="(parentTopic, index) in parentTopics"
                  :key="index"
                  :value="parentTopic.id"
                >
                  {{ parentTopic.name }}
                </option>
              </b-form-select>
              <div v-if="parentTopicEmpty" style="color: red">
                Parent topic is required
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="parentTopic != ''">
              Topic
              <b-form-select v-model="topic" @change="getSubtopics()" required>
                <option
                  v-for="(topic, index) in topics"
                  :key="index"
                  :value="topic.id"
                >
                  {{ topic.name }}
                </option>
              </b-form-select>
              <div v-if="topicEmpty" style="color: red">Topic is required</div>
            </div>

            <div class="col-md-6 form-group" v-if="topic != ''">
              Sub Topic
              <b-form-select v-model="subtopic" @change="getInfo()" required>
                <option
                  v-for="(subtopic, index) in subtopics"
                  :key="index"
                  :value="subtopic.id"
                >
                  {{ subtopic.name }}
                </option>
              </b-form-select>
              <div v-if="subtopicEmpty" style="color: red">
                Subtopic is required
              </div>
            </div>

            <div v-if="subtopic != ''" class="col-md-6 form-group">
              Question Availability Info
              <div
                class="alert alert-info mb-0"
                role="alert"
                style="padding: 6px 12px"
              >
                {{ info }}
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="subtopic != ''">
              Question Count
              <input
                type="number"
                @input="enableAlert()"
                v-model="questionCount"
                class="form-control"
                @focus="(questionCountEmpty = false), (infoAlert = false)"
              />
              <div v-if="questionCountEmpty" style="color: red">
                Question count is required
              </div>
              <div v-if="infoAlert" style="color: red">
                Question count should not be greater than
                {{
                  Number(this.info.split(" ")[1]) +
                  Number(this.info.split(" ")[3])
                }}
              </div>
            </div>

            <div
              class="col-md-6 form-group"
              v-if="
                subtopic != '' &&
                (finalArray2.findIndex(
                  (element) => element.parentTopic.id == parentTopic
                ) >= 0
                  ? false
                  : true)
              "
            >
              Duration (mins)
              <input
                type="number"
                class="form-control"
                v-model="duration2"
                @focus="durationEmpty = false"
              />
              <div v-if="durationEmpty" style="color: red">
                Duration is required
              </div>
            </div>

            <div class="col-md-12" v-if="questionCount != ''">
              <b-button
                variant="success"
                class="float-right ml-2"
                @click="insertRowRandom()"
                >Insert</b-button
              >
              <b-button
                variant="danger"
                class="float-right"
                @click="cancelRandom()"
                >Cancel</b-button
              >
            </div>
          </div>
        </b-modal>

        <div
          class="text-center form-group"
          style="width: 100%"
          v-if="finalArray2 != ''"
        >
          <b-button variant="success" @click="saveRandom()">Save</b-button>
        </div>
      </div>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    removeRowRandom(index, parentTopic) {
      console.log(parentTopic);
      this.finalArray2.splice(index, 1);
      var hasParentTopic = this.finalArray2.filter(
        (ele) => ele.parentTopic.id == parentTopic.id
      );
      if (!hasParentTopic.length > 0) {
        let index = this.durations2.findIndex(
          (ele) => ele.id == parentTopic.id
        );
        console.log(index);
        this.durations2.splice(index, 1);
        hasParentTopic = true;
      }
    },

    async saveRandom() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      if (this.negativeMarks == "") {
        this.negativeMarkEmpty = true;
        return;
      }
      if (this.eachQuestionMark == "") {
        this.eachQuestionMarkEmpty = true;
        return;
      }
      if (this.resultStatus == "") {
        this.resultStatusEmpty = true;
        return;
      }
      var temp_data = [];
      this.finalArray2.forEach((ele) => {
        let {
          parentTopic = {},
          topic = {},
          subtopic = {},
          questionCount = 0,
        } = ele;
        let parentIndex = temp_data.findIndex(
          (temp_ele) => temp_ele.topic_id == parentTopic.id
        );
        if (parentIndex >= 0) {
          temp_data[parentIndex].no_of_questions =
            temp_data[parentIndex].no_of_questions +
            parseInt(ele.questionCount);

          let topicIndex = temp_data[parentIndex].topics.findIndex(
            (temp_ele) => temp_ele.topic_id == topic.id
          );
          if (topicIndex >= 0) {
            let subTopicIndex = temp_data[parentIndex].topics.findIndex(
              (temp_ele) => temp_ele.topic_id == topic.id
            );
            if (subTopicIndex >= 0) {
              let temp_sub_topics =
                temp_data[parentIndex].topics[topicIndex].topics;
              temp_sub_topics.push({
                topic_id: subtopic.id,
                questions: questionCount,
              });
              temp_data[parentIndex].topics[
                topicIndex
              ].topics = temp_sub_topics;
            } else {
              let temp_sub_topics =
                temp_data[parentIndex].topics[topicIndex].topics;
              temp_sub_topics.push({
                topic_id: subtopic.id,
                questions: questionCount,
              });
              temp_data[parentIndex].topics[
                topicIndex
              ].topics = temp_sub_topics;
            }
          } else {
            let temp_topics = temp_data[parentIndex].topics;
            temp_topics.push({
              topic_id: topic.id,
              topics: [
                {
                  topic_id: subtopic.id,
                  questions: questionCount,
                },
              ],
            });
            temp_data[parentIndex].topics = temp_topics;
          }
        } else {
          temp_data.push({
            topic_id: parentTopic.id,
            no_of_questions: parseInt(ele.questionCount),
            duration: this.durations2.find((ele) => ele.id == parentTopic.id)
              .duration2,
            topics: [
              {
                topic_id: topic.id,
                topics: [
                  {
                    topic_id: subtopic.id,
                    questions: questionCount,
                  },
                ],
              },
            ],
          });
        }
      });
      console.log(temp_data);
      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("description", this.description);
      formdata.append("negative_mark", this.negativeMarks);
      formdata.append("each_question_mark", this.eachQuestionMark);
      formdata.append("result_status", this.resultStatus);

      for (var i = 0; i < temp_data.length; i++) {
        formdata.append("topics[" + i + "][topic_id]", temp_data[i].topic_id);
        formdata.append("topics[" + i + "][duration]", temp_data[i].duration);
        formdata.append(
          "topics[" + i + "][no_of_questions]",
          temp_data[i].no_of_questions
        );
        for (var j = 0; j < temp_data[i].topics.length; j++) {
          formdata.append(
            "topics[" + i + "][topics][" + j + "][topic_id]",
            temp_data[i].topics[j].topic_id
          );
          for (var k = 0; k < temp_data[i].topics[j].topics.length; k++) {
            formdata.append(
              "topics[" +
                i +
                "][topics][" +
                j +
                "][topics][" +
                k +
                "][topic_id]",
              temp_data[i].topics[j].topics[k].topic_id
            );
            formdata.append(
              "topics[" +
                i +
                "][topics][" +
                j +
                "][topics][" +
                k +
                "][questions]",
              temp_data[i].topics[j].topics[k].questions
            );
            console.log(
              "questions",
              temp_data[i].topics[j].topics[k].questions
            );
          }
        }
      }

      await axios
        .post(
          `${this.$store.getters.baseUrl}/daily-challenge/pattern`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal(
              "Success",
              "Daily challenge test added successfully",
              "success"
            );
            this.$router.push({ name: "Daily Challenge" });
            (this.name = ""),
              (this.description = ""),
              (this.negativeMarks = ""),
              (this.eachQuestionMark = ""),
              (this.resultStatus = ""),
              (this.durations2 = []),
              (this.finalArray2 = []);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    insertRowRandom() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }
      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }
      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }
      if (this.questionCount == "") {
        this.questionCountEmpty = true;
        return;
      }
      if (
        this.finalArray2.findIndex(
          (element) => element.parentTopic.id == this.parentTopic
        ) >= 0
          ? false
          : true
      ) {
        if (this.duration2 == "") {
          this.durationEmpty = true;
          return;
        }
      }
      this.durationEmpty = false;

      var selectedParentTopic = "";
      for (var i = 0; i < this.parentTopics.length; i++) {
        if (this.parentTopics[i].id == this.parentTopic) {
          selectedParentTopic = this.parentTopics[i];
        }
      }
      var selectedTopic = "";
      for (var j = 0; j < this.topics.length; j++) {
        if (this.topics[j].id == this.topic) {
          selectedTopic = this.topics[j];
        }
      }
      var selectedSubtopic = "";
      for (var k = 0; k < this.subtopics.length; k++) {
        if (this.subtopics[k].id == this.subtopic) {
          selectedSubtopic = this.subtopics[k];
        }
      }

      this.finalArray2.push({
        parentTopic: selectedParentTopic,
        topic: selectedTopic,
        subtopic: selectedSubtopic,
        questionCount: this.questionCount,
      });

      if (this.duration2 != "") {
        var data = this.parentTopics.find((ele) => ele.id == this.parentTopic);
        this.durations2.push({
          id: data.id,
          name: data.name,
          duration2: this.duration2,
        });
      }

      this.parentTopic = "";
      (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.duration2 = "");
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      this.$refs.modalthree.hide();
    },
    cancelRandom() {
      this.parentTopic = "";
      (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.duration2 = "");
      (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.questionCountEmpty = false),
        (this.infoAlert = false);
      this.durationEmpty = false;
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      this.$refs.modalthree.hide();
    },

    enableAlert() {
      if (
        Number(this.questionCount) >
        Number(this.info.split(" ")[1]) + Number(this.info.split(" ")[3])
      ) {
        this.infoAlert = true;
      }
    },

    closeRandom() {
      this.parentTopic = "";
      (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.duration2 = "");
      (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.questionCountEmpty = false),
        (this.infoAlert = false);
      this.durationEmpty = false;
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
    },

    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.subtopic = "";
      this.topic = "";
      this.duration = "";
      this.duration2 = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      this.duration = "";
      this.duration2 = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subtopics = response.data.topics.filter((sub_ele) =>
              this.finalArray2.findIndex(
                (element) => element.subtopic.id == sub_ele.id
              ) >= 0
                ? false
                : true
            );
            console.log(this.subtopics);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getInfo() {
      this.subtopicEmpty = false;
      console.log(this.subtopic);
      await axios
        .get(
          `${this.$store.getters.baseUrl}/recruitment-drives/question-count/${this.subtopic}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.info = `Fillups: ${response.data.number_of_fill_in_blank} MCQ: ${response.data.number_of_objective} Group Question: ${response.data.number_of_group} Coding: ${response.data.number_of_coding}`;
          }
        });
    },
  },
  data() {
    return {
      infoAlert: false,
      questionCountEmpty: false,
      resultStatusEmpty: false,
      eachQuestionMarkEmpty: false,
      negativeMarkEmpty: false,
      descriptionEmpty: false,
      nameEmpty: false,
      durations2: [],
      info: "",
      finalArray2: [],
      duration2: "",
      questionCount: "",
      durationEmpty: false,
      parentTopicEmpty: false,
      topicEmpty: false,
      subtopicEmpty: false,
      eachQuestionMark: "",
      negativeMarks: "",
      description: "",
      name: "",
      resultStatus: "",
      resultStatusOptions: [
        { text: "No Result", value: 3 },
        { text: "Result", value: 1 },
        { text: "Result & Solution", value: 2 },
      ],
      parentTopic: "",
      parentTopics: [],
      topic: "",
      topics: [],
      subtopic: "",
      subtopics: [],
    };
  },
};
</script>
